import React from 'react';
import { withRouter } from 'react-router';
import PasswordReset from '../components/forms/PasswordReset';
import forgotPasswordImage from '../images/forgot_password.png';
import kavtekLogo from '../images/kavtekLogo.png';

function passwordReset() {
	return (
		<>
			<img src={kavtekLogo} alt='Kavtek Logo' className='forgotPassword-logo' />
			<img
				src={forgotPasswordImage}
				alt='Forgot Password Image'
				className='forgotPasswordImage'
			/>
			<PasswordReset />
		</>
	);
}

export default withRouter(passwordReset);
